export default __webpack_public_path__ + "static/Tooltips2-4fc15320ee57c1752e9d42e418cfd554.mp4";